import { createAction } from '@reduxjs/toolkit';

const descriptionGenerationFailed = createAction('asset/descriptionGenerationFailed', (describingFailedAssets) => ({
  payload: { assetsIds: describingFailedAssets.map(({ _id }) => _id) },
}));

export default descriptionGenerationFailed;
